import _ from "lodash"

const parserPadrao = { mach: (laudo) => false, parser: (laudo) => "" }

const generateObjExport = (indicadorAbrev, index, laudo, apont, mediaColetas, coletas) => {
    return {
        indicador: indicadorAbrev,
        APONT_IDENT: laudo.sequencialIndex + indicadorAbrev + index,
        LAUDOTCH: laudo.sequencialIndex || '',
        LAUDOTCH_UID: laudo.uid || '',
        DATA_AMOSTRA: laudo.data || '',
        COD_FAZENDA: laudo.fazenda.codFazenda || '',
        NOME_FAZENDA: laudo.fazenda.nomeFazenda || '',
        COD_TALHAO: apont.talhao.nome || '',
        MEDIA_COLETAS: mediaColetas || '',
        COD_EQUIPAMENTO: apont && apont.trator && apont.trator.numeroFrotaTrator ? apont.trator.numeroFrotaTrator : '',
        PLANTIO: apont && apont.tipo ? apont.tipo : '',
        COD_IMPLEMENTO: apont && apont.implemento && apont.implemento.nomeImplemento ? apont.implemento.nomeImplemento : '',
        TURNO: apont.turno || '',
        FRENTE: apont.frente || '',
        DOSAGEM_RECOMENDADA: apont && apont.dosagemRecomendada ? apont.dosagemRecomendada : '',
        TOTAL_TOLETES: apont && apont.totalToletes ? apont.totalToletes : '',
        CONFORMIDADE: apont.conformidade || '',
        COLETAS: [...coletas],
    }
}

const parserPlantio = {
    mach: (laudo) => {
        let arrPath = ['cm', 'vcc', 'adf', 'ttp', 'ngv', 'ees', 'ps', 'altc']

        for (let i = 0; i < arrPath.length; i++) {
            if (_.get(laudo, `apontamentos.plantio.${arrPath[i]}`)) { return true }
        }

        return false
    },
    parser: (laudo, valueFile) => {
        let ngv = _.get(laudo, "apontamentos.plantio.ngv")
        if (ngv) {
            for (let index = 0; index < ngv.length; index++) {
                const apont = ngv[index]
                let sum = 0, qtd = 0

                let coletas = []
                if (apont.coletas) {
                    apont.coletas.forEach((c) => {
                        sum = sum + parseFloat(c.qtdGemas)
                        qtd = qtd + 1

                        coletas.push({
                            gemasViaveis: c.qtdGemas,
                            gemasDanificadas: parseInt(c.danosMecanico || 0) + parseInt(c.danosPragasClima || 0),
                            gemasMetro: c.qtdGemasMetro,
                        })
                    })
                }

                let objExport = generateObjExport("ngv", index, laudo, apont, (sum / qtd), coletas)

                valueFile.push(objExport)
            }
        }

        let ees = _.get(laudo, "apontamentos.plantio.ees")
        if (ees) {
            for (let index = 0; index < ees.length; index++) {
                const apont = ees[index]
                let sum = 0, qtd = 0

                let coletas = []
                if (apont.coletas) {
                    apont.coletas.forEach((c) => {
                        sum = sum + parseFloat(c.espacamento)
                        qtd = qtd + 1

                        coletas.push({ espacamento: c.espacamento })
                    })
                }

                let objExport = generateObjExport("ees", index, laudo, apont, (sum / qtd), coletas)

                valueFile.push(objExport)
            }
        }

        let ps = _.get(laudo, "apontamentos.plantio.ps")
        if (ps) {
            for (let index = 0; index < ps.length; index++) {
                const apont = ps[index]
                let sum = 0, qtd = 0

                let coletas = []
                if (apont.coletas) {
                    apont.coletas.forEach((c) => {
                        sum = sum + parseFloat(c.profundidade)
                        qtd = qtd + 1

                        coletas.push({ profundidade: c.profundidade })
                    })
                }

                let objExport = generateObjExport("ps", index, laudo, apont, (sum / qtd), coletas)

                valueFile.push(objExport)
            }
        }

        let altc = _.get(laudo, "apontamentos.plantio.altc")
        if (altc) {
            for (let index = 0; index < altc.length; index++) {
                const apont = altc[index]
                let sum = 0, qtd = 0

                let coletas = []
                if (apont.coletas) {
                    apont.coletas.forEach((c) => {
                        sum = sum + parseFloat(c.alturaCobricao)
                        qtd = qtd + 1

                        coletas.push({ alturaCobricao: c.alturaCobricao })
                    })
                }

                let objExport = generateObjExport("altc", index, laudo, apont, (sum / qtd), coletas)

                valueFile.push(objExport)
            }
        }

        let cm = _.get(laudo, "apontamentos.plantio.cm")
        if (cm) {
            for (let index = 0; index < cm.length; index++) {
                const apont = cm[index]
                let sum = 0, qtd = 0

                let coletas = []
                if (apont.coletas) {
                    apont.coletas.forEach((c) => {
                        sum = sum + parseFloat(c.peso)
                        qtd = qtd + 1

                        coletas.push({ peso: c.peso })
                    })
                }

                let objExport = generateObjExport("cm", index, laudo, apont, (sum / qtd), coletas)

                valueFile.push(objExport)
            }
        }

        let vcc = _.get(laudo, "apontamentos.plantio.vcc")
        if (vcc) {
            for (let index = 0; index < vcc.length; index++) {
                const apont = vcc[index]
                let sum = 0, qtd = 0

                let coletas = []
                if (apont.coletas) {
                    apont.coletas.forEach((c) => {
                        sum = sum + parseFloat(c.pesagem)
                        qtd = qtd + 1

                        coletas.push({ pesagem: c.pesagem })
                    })
                }

                let objExport = generateObjExport("vcc", index, laudo, apont, (sum / qtd), coletas)

                valueFile.push(objExport)
            }
        }

        let adf = _.get(laudo, "apontamentos.plantio.adf")
        if (adf) {
            for (let index = 0; index < adf.length; index++) {
                const apont = adf[index]
                let sum = 0, qtd = 0

                let coletas = []
                if (apont.coletas) {
                    apont.coletas.forEach((c) => {
                        sum = sum + parseFloat(c.pesagem)
                        qtd = qtd + 1

                        coletas.push({ pesagem: c.pesagem })
                    })
                }

                let objExport = generateObjExport("adf", index, laudo, apont, (sum / qtd), coletas)

                valueFile.push(objExport)
            }
        }

        let ttp = _.get(laudo, "apontamentos.plantio.ttp")
        if (ttp) {
            for (let index = 0; index < ttp.length; index++) {
                const apont = ttp[index]
                let sum = 0, qtd = 0

                let coletas = []
                if (apont.coletas) {
                    apont.coletas.forEach((c) => {
                        sum = sum + parseFloat(c.tolete)
                        qtd = qtd + 1

                        coletas.push({
                            conforme: c.conforme,
                            tolete: parseFloat(c.tolete),
                        })
                    })
                }

                let objExport = generateObjExport("ttp", index, laudo, apont, (sum / qtd), coletas)

                valueFile.push(objExport)
            }
        }
    },
}

let parsers = [parserPlantio, parserPadrao]

export function exportFile(laudos, props) {
    let valueFile = []
    laudos.forEach((laudo) => {
        for (let index = 0; index < parsers.length; index++) {
            const parser = parsers[index]
            if (parser.mach(laudo)) {
                parser.parser(laudo, valueFile)
            }
        }
    })

    gerarArquivo(JSON.stringify(valueFile), "Export.json")
}

const gerarArquivo = (jsonse, nome) => {
    let fileBlob = new Blob([jsonse], { type: "application/json" })
    if (window.cordova) {
        document.addEventListener("deviceready", function () {
            var storageLocation = ""
            console.log("window.cordova", window.cordova)
            storageLocation = window.cordova.file.dataDirectory

            var folderPath = storageLocation
            console.log("folderPath", folderPath)
            console.log("nome", nome)
            window.resolveLocalFileSystemURL(
                folderPath,
                function (dir) {
                    console.log("Access to the directory granted succesfully", dir)
                    dir.getFile(
                        nome,
                        {
                            create: true,
                        },
                        function (file) {
                            console.log("file", file)
                            file.createWriter(
                                function (fileWriter) {
                                    fileWriter.write(fileBlob)

                                    fileWriter.onwriteend = function () {
                                        var url = file.toURL()
                                        console.log("url", url)
                                        window.cordova.plugins.fileOpener2.open(folderPath + nome, "text/plain", {
                                            error: function error(err) {
                                                console.error(err)
                                                alert("Unable to download3")
                                            },
                                            success: function success() {
                                                console.log("success with opening the file")
                                            },
                                        })
                                    }

                                    fileWriter.onerror = function (err) {
                                        alert("Unable to download2")
                                        console.error(err)
                                    }
                                },
                                function (err) {
                                    // failed
                                    alert("Unable to download")
                                    console.error("err", err)
                                }
                            )
                        },
                        function (err) {
                            alert("Unable to download")
                            console.error(err)
                        }
                    )
                },
                function (err) {
                    alert("Unable to download")
                    console.error(err)
                }
            )
        })
    } else {
        var element = document.createElement("a")

        element.href = URL.createObjectURL(fileBlob)
        element.download = nome
        element.click()
    }
}

const configExport = { nome: "Exportar JSON Plantio", exportFile: exportFile }
export default configExport
